const editInvoiceDialogConstantsAR = {
  editInvoiceDialogHeader: 'تعديل الإيصال',
  editInvoiceDialogSaveButton: 'تعديل الإيصال',
  editInvoicePlaceholder: 'الحالة',
};

export default editInvoiceDialogConstantsAR;
